export default __webpack_public_path__ + "static/eth-1751a93d188785263db889a4a951e1c2.png";